export const IS_LIMIT_REACHED_KEY_ERROR = 'isLimitReached'; 
export const IS_NOT_ENOUGH_KEY_ERROR = 'isNotEnough';
export const IS_NOT_MULTIPLE_KEY_ERROR = 'isNotMultiple';

export const sortByQuantity = (a, b) => a.minQty - b.minQty;

export const createPriceUniqueKey = (price) => price.distributor + price.manufacturer + price.packerId + price.productId + price.sourceId;

export const showPricesWithSpaces = (priceValue) => {
    const parts = priceValue.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
};

export const cartManager = {
    observersList: [],
    currentPrices: {},
    getMinOrderQuantity(price) {
        const quantities = Array.isArray(price?.quantities) ? [...price.quantities].sort(sortByQuantity) : [];
        const minQty = quantities[0]?.minQty;
        return Number.isFinite(minQty) && minQty > 0 ? minQty : 1;
    },
    isCountMultiple(minOrderQuantity, count) {
        if (count === 0) return true;
        if (count < minOrderQuantity) return false;
        if (minOrderQuantity <= 1) return true;
        return count % minOrderQuantity === 0;
    },
    registerCartObserver(observer) {
        this.observersList.push(observer);
    },

    unRegisterCartObserver(observer) {
        try {
            this.observersList = this.observersList.filter(observerItem => observerItem !== observer);
            this.currentPrices = {};
        } catch(err) {
            console.log(err);
        }
    },

    notifyCartObservers() {
        this.observersList.forEach(observer => observer(Object.values(this.currentPrices)));
    },
    
    setProductsCount(price, count) {
        price.count = count;
        if(!this.isLimitReached(price) && this.isCountEnough(price)) {
            this.currentPrices[createPriceUniqueKey(price)] = price;
            this.notifyCartObservers();
            return {};
        } else {
            let errorKey = IS_NOT_ENOUGH_KEY_ERROR;
            if (this.isLimitReached(price)) {
                errorKey = IS_LIMIT_REACHED_KEY_ERROR;
            } else {
                const minOrderQuantity = this.getMinOrderQuantity(price);
                if (price.count > 0 && price.count >= minOrderQuantity && !this.isCountMultiple(minOrderQuantity, price.count)) {
                    errorKey = IS_NOT_MULTIPLE_KEY_ERROR;
                }
            }
            const error = {error: errorKey};
            price.count = 0;
            this.currentPrices[createPriceUniqueKey(price)] = price;
            return error;
        }
    },

    isLimitReached(price) {
        return price.stockNumber < price.count;
    },

    isCountEnough(price) {
        if (price) {
            const minOrderQuantity = this.getMinOrderQuantity(price);
            return this.isCountMultiple(minOrderQuantity, price.count);
        }

        return Object.values(this.currentPrices).every((p) => {
            const minOrderQuantity = this.getMinOrderQuantity(p);
            return this.isCountMultiple(minOrderQuantity, p.count);
        });
    },

    getCurrentPrices() {
        return this.currentPrices;
    },
    
    clearService() {
        this.currentPrices = {};
        this.notifyCartObservers();
    },
};